import { Box, Button, NumberField } from '@factorialco/deprecated-design-system'
import { ShiftManagementRolesRequirementsFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { RolesRequirements } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/CoverageSection/Body/RolesRequirements/index'
import type UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'

interface Props {
  form: UnassignedShiftForm
  id: number
  min?: number
  roles: ShiftManagementRolesRequirementsFragment[]
}

const StaffRequirements = observer(({ form, id, min = 1, roles }: Props) => {
  const handleStaffChange = (newCounter: number | null) => {
    const prevRequirements = [...form.get('staff_requirements').value]
    prevRequirements[id] = {
      ...prevRequirements[id],
      staff_count: newCounter,
    }
    form.setValues({ staff_requirements: prevRequirements })
  }

  const handleDeleteRequirement = () => {
    const prevRequirements = [...form.get('staff_requirements').value]
    prevRequirements.splice(id, 1)
    form.setValues({ staff_requirements: prevRequirements })
  }

  return (
    <Box flexDirection="row" gap="s4" alignItems="flexStart">
      <Box width="s96" minWidth="s96">
        <NumberField
          locale="en"
          label={
            id === 0
              ? i18n.t(
                  'shift_management.coverage_section.unassigned_shift.staff_requirements.staff_title'
                )
              : ''
          }
          min={min}
          onChange={(value: number | null) => handleStaffChange(value)}
          step={1}
          value={form.get('staff_requirements').value[id]?.staff_count}
          missingLabel={
            id === 0
              ? i18n.t(
                  'shift_management.coverage_section.unassigned_shift.staff_requirements.staff_title'
                )
              : ''
          }
          selectValue={form.get('staff_requirements').value[id]?.staff_count}
        />
      </Box>
      <Box flexGrow width="full">
        <RolesRequirements form={form} id={id} roles={roles} />
      </Box>
      {form.get('staff_requirements').value.length > 1 && (
        <Box
          height="s32"
          width="s32"
          alignSelf={id === 0 ? 'end' : 'center'}
          style={{
            marginBottom: id === 0 ? '7px' : '',
          }}
        >
          <Button type="secondary" onClick={handleDeleteRequirement} iconName="delete" />
        </Box>
      )}
    </Box>
  )
})

export { StaffRequirements }
